<div class="cp-view">
    <div class="cp-shell">
        <div class="cp-topbar">
            <div class="cp-title-wrap">
                <button type="button" class="cp-back" (click)="goBack()" aria-label="Regresar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M4 11.9998L20 11.9998" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.99996 17C8.99996 17 4.00001 13.3176 4 12C3.99999 10.6824 9 7.00001 9 7.00001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <h4 class="cp-page-title">Carta porte - Folio {{ serviceFolio }}</h4>
            </div>

            <div class="cp-actions">
                <button type="button" class="cp-link-btn" (click)="downloadXml()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M15.6618 13H14.7126C14.3334 13 14.1437 13 13.9941 13.0634C13.4847 13.2795 13.4916 13.7873 13.4916 14.25C13.4916 14.7127 13.4847 15.2205 13.9941 15.4366C14.1437 15.5 14.3334 15.5 14.7126 15.5C15.0919 15.5 15.2816 15.5 15.4312 15.5634C15.9406 15.7795 15.9337 16.2873 15.9337 16.75C15.9337 17.2127 15.9406 17.7205 15.4312 17.9366C15.2816 18 15.0919 18 14.7126 18H13.6789M8 13L9.70791 15.5M9.70791 15.5L11.4158 18M9.70791 15.5L11.4158 13M9.70791 15.5L8 18M21 18H20.146C19.3409 18 18.9384 18 18.6883 17.7559C18.4381 17.5118 18.4381 17.119 18.4381 16.3333V13" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15 22H10.7273C7.46607 22 5.83546 22 4.70307 21.2022C4.37862 20.9736 4.09058 20.7025 3.8477 20.3971C3 19.3313 3 17.7966 3 14.7273V12.1818C3 9.21865 3 7.73706 3.46894 6.55375C4.22281 4.65142 5.81714 3.15088 7.83836 2.44135C9.09563 2 10.6698 2 13.8182 2C15.6173 2 16.5168 2 17.2352 2.2522C18.3902 2.65765 19.3012 3.5151 19.732 4.60214C20 5.27832 20 6.12494 20 7.81818V10" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M3 12C3 10.1591 4.49238 8.66667 6.33333 8.66667C6.99912 8.66667 7.78404 8.78333 8.43137 8.60988C9.00652 8.45576 9.45576 8.00652 9.60988 7.43136C9.78333 6.78404 9.66667 5.99912 9.66667 5.33333C9.66667 3.49238 11.1591 2 13 2" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Descargar XML
                </button>
                <button type="button" class="cp-link-btn" (click)="downloadPdf()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M7 18V15.5M7 15.5V14C7 13.5286 7 13.2929 7.15377 13.1464C7.30754 13 7.55503 13 8.05 13H8.75C9.47487 13 10.0625 13.5596 10.0625 14.25C10.0625 14.9404 9.47487 15.5 8.75 15.5H7ZM21 13H19.6875C18.8625 13 18.4501 13 18.1938 13.2441C17.9375 13.4882 17.9375 13.881 17.9375 14.6667V15.5M17.9375 18V15.5M17.9375 15.5H20.125M15.75 15.5C15.75 16.8807 14.5747 18 13.125 18C12.7979 18 12.6343 18 12.5125 17.933C12.2208 17.7726 12.25 17.448 12.25 17.1667V13.8333C12.25 13.552 12.2208 13.2274 12.5125 13.067C12.6343 13 12.7979 13 13.125 13C14.5747 13 15.75 14.1193 15.75 15.5Z" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15 22H10.7273C7.46607 22 5.83546 22 4.70307 21.2022C4.37862 20.9736 4.09058 20.7025 3.8477 20.3971C3 19.3313 3 17.7966 3 14.7273V12.1818C3 9.21865 3 7.73706 3.46894 6.55375C4.22281 4.65142 5.81714 3.15088 7.83836 2.44135C9.09563 2 10.6698 2 13.8182 2C15.6173 2 16.5168 2 17.2352 2.2522C18.3902 2.65765 19.3012 3.5151 19.732 4.60214C20 5.27832 20 6.12494 20 7.81818V10" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M3 12C3 10.1591 4.49238 8.66667 6.33333 8.66667C6.99912 8.66667 7.78404 8.78333 8.43137 8.60988C9.00652 8.45576 9.45576 8.00652 9.60988 7.43136C9.78333 6.78404 9.66667 5.99912 9.66667 5.33333C9.66667 3.49238 11.1591 2 13 2" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Descargar PDF
                </button>
            </div>
        </div>

        <section class="cp-section">
            <h5 class="cp-section-title">Dirección</h5>

            <div class="cp-card">
                <div class="cp-subtitle">Origen</div>
                <div class="cp-address-line">{{ selectedService?.origin_address || 'N/A' }}</div>

                <div class="row g-3">
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Código postal</div>
                        <div class="cp-field-value">{{ getAddressValue(originAddress, 'c_CodigoPostal', 'codigo_postal') }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">País</div>
                        <div class="cp-field-value">{{ getAddressValue(originAddress, 'pais') === 'N/A' ? 'MEX' : getAddressValue(originAddress, 'pais') }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Estado</div>
                        <div class="cp-field-inline">
                            <span>{{ getAddressValue(originAddress, 'estadoDescripcion', 'estado') }}</span>
                            <span class="cp-badge">{{ getAddressValue(originAddress, 'c_Estado') }}</span>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Municipio</div>
                        <div class="cp-field-inline">
                            <span>{{ getAddressValue(originAddress, 'municipioDescripcion', 'municipio') }}</span>
                            <span class="cp-badge">{{ getAddressValue(originAddress, 'c_Municipio') }}</span>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Código de localidad</div>
                        <div class="cp-field-inline">
                            <span>{{ getAddressValue(originAddress, 'localidadDescripcion', 'localidad') }}</span>
                            <span class="cp-badge">{{ getAddressValue(originAddress, 'c_Localidad') }}</span>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Código de colonia</div>
                        <div class="cp-field-inline">
                            <span>{{ getAddressValue(originAddress, 'coloniaDescripcion', 'colonia') }}</span>
                            <span class="cp-badge">{{ getAddressValue(originAddress, 'c_Colonia') }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cp-card">
                <div class="cp-subtitle">Destino</div>
                <div class="cp-address-line">{{ selectedService?.destination_address || 'N/A' }}</div>

                <div class="row g-3">
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Código postal</div>
                        <div class="cp-field-value">{{ getAddressValue(destinationAddress, 'c_CodigoPostal', 'codigo_postal') }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">País</div>
                        <div class="cp-field-value">{{ getAddressValue(destinationAddress, 'pais') === 'N/A' ? 'MEX' : getAddressValue(destinationAddress, 'pais') }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Estado</div>
                        <div class="cp-field-inline">
                            <span>{{ getAddressValue(destinationAddress, 'estadoDescripcion', 'estado') }}</span>
                            <span class="cp-badge">{{ getAddressValue(destinationAddress, 'c_Estado') }}</span>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Municipio</div>
                        <div class="cp-field-inline">
                            <span>{{ getAddressValue(destinationAddress, 'municipioDescripcion', 'municipio') }}</span>
                            <span class="cp-badge">{{ getAddressValue(destinationAddress, 'c_Municipio') }}</span>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Código de localidad</div>
                        <div class="cp-field-inline">
                            <span>{{ getAddressValue(destinationAddress, 'localidadDescripcion', 'localidad') }}</span>
                            <span class="cp-badge">{{ getAddressValue(destinationAddress, 'c_Localidad') }}</span>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Código de colonia</div>
                        <div class="cp-field-inline">
                            <span>{{ getAddressValue(destinationAddress, 'coloniaDescripcion', 'colonia') }}</span>
                            <span class="cp-badge">{{ getAddressValue(destinationAddress, 'c_Colonia') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="cp-section">
            <h5 class="cp-section-title">Transporte y distancia</h5>
            <div class="cp-card">
                <div class="row g-3">
                    <div class="col-md-6">
                        <div class="cp-field-label">Medio de transporte</div>
                        <div class="cp-field-value">{{ transportMeanLabel }}</div>
                    </div>
                    <div class="col-md-6">
                        <div class="cp-field-label">Total de distancia recorrida</div>
                        <div class="cp-field-value">{{ cartaPorte?.total_distance || 0 }} KM</div>
                    </div>
                </div>
            </div>
        </section>

        <section class="cp-section">
            <h5 class="cp-section-title">Detalles de mercancía</h5>
            <div class="cp-card">
                <div class="row g-3">
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Valor de la mercancía</div>
                        <div class="cp-field-value">{{ cartaPorte?.cfdi_subtotal | currency }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Peso bruto total</div>
                        <div class="cp-field-value">{{ cartaPorte?.gross_weight_total || 'N/A' }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Unidad de peso</div>
                        <div class="cp-field-value">{{ cartaPorte?.weight_unit?.name || 'N/A' }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Dimensiones</div>
                        <div class="cp-field-value">{{ cartaPorte?.dimensions || 'N/A' }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Unidad de medida</div>
                        <div class="cp-field-value">{{ cartaPorte?.measurement_unit?.name || 'N/A' }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Total número de mercancías</div>
                        <div class="cp-field-value">{{ cartaPorte?.total_goods || 'N/A' }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Tipo de logística</div>
                        <div class="cp-field-value">{{ cartaPorte?.logistics_type?.name || 'N/A' }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">¿La mercancía es peligrosa?</div>
                        <div class="cp-field-value">{{ cartaPorte?.hazardous_material_option?.name || 'N/A' }}</div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <div class="cp-field-label">Tipo de mercancía transportada</div>
                        <div class="cp-field-value">{{ cartaPorte?.unit_key?.name || 'N/A' }}</div>
                    </div>
                </div>
            </div>
        </section>

        <section class="cp-section">
            <h5 class="cp-section-title">Detalles e identificación del autotransporte</h5>
            <div class="cp-card">
                <div class="row g-3">
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Permiso de SCT</div>
                        <div class="cp-field-value">{{ permitLabel }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Número de permiso SCT</div>
                        <div class="cp-field-value">{{ selectedService?.unit?.permit_number || 'N/A' }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Tipo de vehículo</div>
                        <div class="cp-field-value">{{ vehicleConfigurationLabel }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Placa del vehículo</div>
                        <div class="cp-field-value">{{ selectedService?.unit?.plates || 'N/A' }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Año del vehículo</div>
                        <div class="cp-field-value">{{ selectedService?.unit?.unit_year || 'N/A' }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Peso bruto del vehículo</div>
                        <div class="cp-field-value">{{ selectedService?.unit?.peso_bruto ? (selectedService?.unit?.peso_bruto | number:'1.0-0') + ' KG' : 'N/A' }}</div>
                    </div>
                </div>
            </div>
        </section>

        <section class="cp-section">
            <h5 class="cp-section-title">Seguro</h5>
            <div class="cp-card">
                <div class="row g-3">
                    <div class="col-md-3 col-sm-6">
                        <div class="cp-field-label">Aseguradora de responsabilidad civil</div>
                        <div class="cp-field-value">{{ selectedService?.unit?.liability_insurer?.name || 'N/A' }}</div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="cp-field-label">Número de póliza de seguro por responsabilidad civil</div>
                        <div class="cp-field-value">{{ selectedService?.unit?.liability_policy_number || 'N/A' }}</div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="cp-field-label">Aseguradora de daños al medio ambiente</div>
                        <div class="cp-field-value">{{ selectedService?.unit?.environmental_insurer?.name || 'N/A' }}</div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="cp-field-label">Número de póliza de seguro por daños al medio ambiente</div>
                        <div class="cp-field-value">{{ selectedService?.unit?.environmental_policy_number || 'N/A' }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Aseguradora de la carga transportada</div>
                        <div class="cp-field-value">{{ insurerName }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Número de póliza de seguro de la carga</div>
                        <div class="cp-field-value">{{ cartaPorte?.cargo_insurance_policy_number || 'N/A' }}</div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="cp-field-label">Valor de la prima del seguro</div>
                        <div class="cp-field-value">{{ cartaPorte?.insurance_premium_value ? (cartaPorte?.insurance_premium_value | currency) : 'N/A' }}</div>
                    </div>
                </div>
            </div>
        </section>

        <section class="cp-section">
            <h5 class="cp-section-title">Impuestos CFDI</h5>
            <div class="cp-card cp-tax-card">
                <div class="cp-tax-summary">
                    <div class="cp-tax-row">
                        <span>Subtotal</span>
                        <strong>{{ cartaPorte?.cfdi_subtotal | currency }}</strong>
                    </div>
                    <div class="cp-tax-row">
                        <span>Impuestos (16.00%)</span>
                        <strong>{{ cartaPorte?.cfdi_taxes?.TotalImpuestosTrasladados | currency }}</strong>
                    </div>
                    <div class="cp-tax-row cp-tax-total">
                        <span>Total gastos de traslado</span>
                        <strong>{{ cartaPorte?.cfdi_total | currency }}</strong>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
